function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M66.2109 106.641H84.668V0H66.2109V44.3848H18.5303V0H0V106.641H18.5303V59.2529H66.2109V106.641ZM105.477 109H145.164V98.8438H122.781L130.125 90.3672C134.031 86.4609 136.857 83.349 138.602 81.0312C140.372 78.6875 141.674 76.4609 142.508 74.3516C143.341 72.2161 143.758 70.0286 143.758 67.7891C143.758 62.4766 142.091 58.401 138.758 55.5625C135.451 52.724 130.724 51.3047 124.578 51.3047C120.75 51.3047 117.286 52.138 114.188 53.8047C111.089 55.4714 108.667 57.7891 106.922 60.7578C105.177 63.7005 104.305 66.9167 104.305 70.4062H117.508C117.508 67.8542 118.133 65.7318 119.383 64.0391C120.633 62.3203 122.26 61.4609 124.266 61.4609C126.297 61.4609 127.846 62.099 128.914 63.375C129.982 64.651 130.516 66.513 130.516 68.9609C130.516 71.9818 128.263 76.0573 123.758 81.1875L105.477 100.406V109Z",
  fill: "black"
});

var SvgH2 = function SvgH2(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 146,
    height: 109,
    viewBox: "0 0 146 109",
    fill: "none",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgH2, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/h2.e4ec6f6c.svg";
export { ForwardRef as ReactComponent };